// Vendorized and altered from https://github.com/WickyNilliams/pure-color

const parse = (hex) => [
  parseInt(hex.substring(1,3), 16),
  parseInt(hex.substring(3,5), 16),
  parseInt(hex.substring(5,7), 16)
];

export const clamp = (val, min, max) => Math.min(Math.max(val, min), max);

function rgb2hsv(rgb) {
  let r = rgb[0];
  let g = rgb[1];
  let b = rgb[2];
  let min = Math.min(r, g, b);
  let max = Math.max(r, g, b);
  let delta = max - min;
  let h, s, v;

  if (max === 0)
    s = 0;
  else
    s = (delta/max * 1000)/10;

  if (max === min)
    h = 0;
  else if (r === max)
    h = (g - b) / delta;
  else if (g === max)
    h = 2 + (b - r) / delta;
  else if (b === max)
    h = 4 + (r - g) / delta;

  h = Math.min(h * 60, 360);

  if (h < 0)
    h += 360;

  v = ((max / 255) * 1000) / 10;

  return [h, s, v];
}

function componentToHex(c) {
  let value = Math.round(clamp(c, 0, 255));
  let hex   = value.toString(16);

  return hex.length === 1 ? "0" + hex : hex;
}

function rgb2hex(rgb) {
  return "#" + componentToHex(rgb[0]) + componentToHex(rgb[1]) + componentToHex(rgb[2]);
}

function hsv2rgb(hsv) {
  let h = hsv[0] / 60;
  let s = hsv[1] / 100;
  let v = hsv[2] / 100;
  let hi = Math.floor(h) % 6;

  let f = h - Math.floor(h);
  let p = 255 * v * (1 - s);
  let q = 255 * v * (1 - (s * f));
  let t = 255 * v * (1 - (s * (1 - f)));
  let r = 255 * v;

  switch(hi) {
    case 0:  return [r, t, p];
    case 1:  return [q, r, p];
    case 2:  return [p, r, t];
    case 3:  return [p, q, r];
    case 4:  return [t, p, r];
    case 5:  return [r, p, q];
    default: return [0, 0, 0];
  }
}

function rgb2string(rgb) {
  let scheme = "rgb";

  if(rgb.length === 4) {
    scheme += "a";
  }

  rgb[0] = Math.round(rgb[0]);
  rgb[1] = Math.round(rgb[1]);
  rgb[2] = Math.round(rgb[2]);

  return scheme + "(" + rgb.join(",") + ")";
}

export const parseToHsv = (color) => rgb2hsv(parse(color));

export const toRgbString = (hsv) => rgb2string(hsv2rgb(hsv));

export const toHexString = (hsv) => rgb2hex(hsv2rgb(hsv));
